import styled from '@emotion/styled'

import { getAnimateRotationStyle } from '../../../../utils/getAnimateRotationStyle'

export const LoadingIconWrapper = styled.figure`
  display: flex;
  justify-content: center;
  width: 100%;
  ${getAnimateRotationStyle()};
`
